var map = {
	"./1_Felicitas Ernst_Burger_King_advertising_Publicidad_U0A1908.webp": "./src/img/brands/burgerking/1_Felicitas Ernst_Burger_King_advertising_Publicidad_U0A1908.webp",
	"./Felicitas Ernst_Burger_King_advertising_Publicidad-U0A1793.webp": "./src/img/brands/burgerking/Felicitas Ernst_Burger_King_advertising_Publicidad-U0A1793.webp",
	"./Felicitas Ernst_Burger_King_advertising_Publicidad_U0A1912.webp": "./src/img/brands/burgerking/Felicitas Ernst_Burger_King_advertising_Publicidad_U0A1912.webp",
	"./Felicitas Ernst_Burger_King_advertising_Publicidad_U0A1919.webp": "./src/img/brands/burgerking/Felicitas Ernst_Burger_King_advertising_Publicidad_U0A1919.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/img/brands/burgerking sync \\.(webp%7Cjpg%7Cjpeg%7Cpng)$";